exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-header[data-v-d868151a]{background-color:#fef7ea}.modal-body[data-v-d868151a]{font-size:.9rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-d868151a&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/ThanksDemoQuestionnaireAlert.vue
// module id = 543
// module chunks = 0